import { TooltipHelpIndicatorWrapper } from './TooltipHelpIndicatorWrapper';
import { TooltipHelpIndicatorIcon } from './TooltipHelpIndicatorIcon';

export { TooltipHelpIndicatorIcon };
export default TooltipHelpIndicatorWrapper;
